import {
  isObjectSplits,
  getPhotos,
  getCoordinates,
  checkJKCategory,
  checkBusinessCenterCategory,
  getJKId,
  getBusinessCenterId,
  getJKHouseId,
} from '../../../../../utils/offer';
import { IAppState } from '../../../../types';
import { IConfig } from '@cian/config/shared';
import { IGetPublishTermsRequest } from '../../../../../services/publishTerms';
import { selectIsArchived, selectLocationsFromAddress } from '../../../../../selectors/offer';

interface IGetParametersDependecies {
  state: IAppState;
  config: IConfig;
}

export const getParameters = (params: IGetParametersDependecies): IGetPublishTermsRequest => {
  const { state } = params;
  const { offer } = state;
  const { id, category } = offer;

  const photos = getPhotos(offer);
  const isMultiListing = isObjectSplits(offer);
  const locationPath = selectLocationsFromAddress(state).reverse();
  const { lat, lng } = getCoordinates(offer);
  const isJKCategory = checkJKCategory(offer);
  const isBusinessCenterCategory = checkBusinessCenterCategory(offer);
  const newObjectId = getJKId(offer);
  const newObjectHouseId = getJKHouseId(offer);
  const businessShoppingCenterId = getBusinessCenterId(offer);
  const isFromArchive = selectIsArchived(state);

  return {
    ...(lat && { latitude: lat }),
    ...(lng && { longitude: lng }),
    ...(isJKCategory && { newObjectId, newObjectHouseId }),
    ...(isBusinessCenterCategory && { businessShoppingCenterId }),
    id,
    photosCount: photos.length,
    locationPath,
    category,
    isMultiListing,
    isFromArchive,
  };
};
